
import { Inject } from 'inversify-props'
import type { MetaDiariaServiceAdapter } from './adapter'

export class DeleteMetaDiariaUseCase {
	@Inject('MetaDiariaServiceAdapter')
	private metaService!: MetaDiariaServiceAdapter

	deleteUsuarioMeta = async (metaId: string, id: string): Promise<void> => await this.metaService.deleteUsuarioMeta(metaId, id)

	deleteMeta = async (metaId: string): Promise<void> => await this.metaService.deleteMeta(metaId)
}